import Attendance from '@/components/attendance/Attendance';
import AttendanceList from '@/components/attendance/AttendanceList';

export default 		{
    path: '/attendance',
    component: Attendance,
    children: [
        {
            path: '/',
            name: 'Attendance',
            component: AttendanceList,
        }
    ],
    meta: {requiresAuth: true}
}